module.exports = __webpack_public_path__ + "77a74fcf49b1128b509e0b4309534ac4.png";